import { Directive, ElementRef, HostListener } from '@angular/core';
var NglDropdownItem = (function () {
    function NglDropdownItem(element) {
        this.element = element;
        this.isFocused = false;
    }
    NglDropdownItem.prototype.onFocus = function () {
        this.isFocused = true;
    };
    NglDropdownItem.prototype.onBlur = function () {
        this.isFocused = false;
    };
    NglDropdownItem.prototype.hasFocus = function () {
        return this.isFocused;
    };
    NglDropdownItem.prototype.focus = function () {
        this.element.nativeElement.focus();
    };
    NglDropdownItem.decorators = [
        { type: Directive, args: [{
                    selector: '[nglDropdownItem]',
                    host: {
                        'tabindex': '0',
                    },
                },] },
    ];
    /** @nocollapse */
    NglDropdownItem.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    NglDropdownItem.propDecorators = {
        'onFocus': [{ type: HostListener, args: ['focus',] },],
        'onBlur': [{ type: HostListener, args: ['blur',] },],
    };
    return NglDropdownItem;
}());
export { NglDropdownItem };
//# sourceMappingURL=dropdown-item.js.map